import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=676d774a&scoped=true&"
import script from "./ModalSuccess.vue?vue&type=script&lang=ts&"
export * from "./ModalSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=676d774a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d774a",
  null
  
)

export default component.exports